import HttpService from "./http-service";
import Image from "@/entities/image";

export default class ImageUploadService extends HttpService {
  public async createImage(image: File,defaultDirectoty:string): Promise<Image> {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const formData = new FormData();
    formData.append("image", image);
    formData.append("directory", defaultDirectoty);

    const { data } = await this.httpClient.post<Image>(
      "/images",
      formData,
      config
    );
    return data;
  }

  public deleteImage(imageId: number): Promise<void> {
    return this.httpClient.delete(`/images/${imageId}`);
  }

  /*
  Handle image upload to profile
  */

  public async createProfilePicture(
    image: File,
    user_id: string,
    entity_id: number | null
  ): Promise<Image> {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const formData = new FormData();
    formData.append("image", image);
    formData.append("user_id", user_id);
    // eslint-disable-next-line
    formData.append("entity_id", entity_id!.toString());

    const { data } = await this.httpClient.post<Image>(
      "/profile-picture",
      formData,
      config
    );
    return data;
  }

  public async updateProfilePicture(
    image: File,
    profile_picture_id: number | null
  ): Promise<Image> {
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const formData = new FormData();
    formData.append("image", image);
    formData.append("_method", "PUT");

    const { data } = await this.httpClient.post<Image>(
      `/profile-picture/${profile_picture_id}`,
      formData,
      config
    );
    return data;
  }

  public deletePictureProfile(profile_picture_id: number): Promise<void> {
    return this.httpClient.delete(`/profile-picture/${profile_picture_id}`);
  }


  public async getLogos(){
    return this.httpClient.get('logos')
  }

  public async deleteLogo(logoId:number){
    return this.httpClient.delete(`/logo/${logoId}`)
  }

  public async uploadLogoImage(
      image: File,
      imageType: string,
  ):Promise<Image>{

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };

    const formData = new FormData();
    formData.append("logo", image);
    formData.append("logo_type", imageType);

    const { data } = await this.httpClient.post<Image>(
        '/logo',
        formData,
        config
    )

    return data;
  }
}
